import CalculationTableRecord from "./CalculationTableRecord";
const CalculationsTable = ({ data }) => {
    return (
        <div className="calculations-table-container">
            <table>
                <colgroup>
                    <col style={{width: "75%"}}/>
                    <col style={{width: "5%"}}/>
                    <col style={{width: "5%"}}/>
                    <col style={{width: "5%"}}/>
                    <col style={{width: "5%"}}/>
                    <col style={{width: "5%"}}/>
                </colgroup>
                <tbody>
                    <tr style={{fontWeight: "bold"}}>
                        <td>FlowMeter</td>
                        <td style={{textAlign: "center"}}>Base</td>
                        <td>StdPattern</td>
                        <td>DatetimeFrom</td>
                        <td>DatetimeTo</td>
                        <td>StdCurrent</td>
                    </tr>
                    {data && data.map((record) => {
                        return <CalculationTableRecord
                            key={record.flowMeterName}
                            flowMeterName={record.flowMeterName}
                            base={record.base}
                            statePattern={record.statePattern}
                            stateCurrent={record.stateCurrent}
                            datetimeFrom={record.datetimeFrom}
                            datetimeTo={record.datetimeTo}
                        />
                    })}
                </tbody>
            </table>
        </div>
    )
}
export default CalculationsTable;